<!--企业培育-->
<template>
  <div class="cultivation-container">
    <header-index/>
    <div class="cultivation-content">
      <div class="cultivation-breadcrumb">
        <span>您当前位置：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
              :to="{ path: '/cloudPlatform/platform?city=2&cityName='+childNode.name+'&cityCode='+childNode.cityCode+'&parentCityCode='+childNode.parentCityCode+'&pName='+childNode.name+'企业数字化服务云平台&parName=渝企服务云' }">
            服务平台
          </el-breadcrumb-item>
          <el-breadcrumb-item>企业培育</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="cultivation-info">
        <div class="cultivation-top">
          <p class="cultivation-title">{{ childNode.name }}企业高质量发展培育系统</p>
        </div>
        <div class="cultivation-center">
          <div class="cultivation-btn1" @click="developmentCultivation"><p>企业高质量发展培育俱乐部会员申请表</p></div>
          <div class="cultivation-btn2" @click="declaration"><p>企业服务诉求申报系统</p></div>
          <div class="cultivation-btn3" @click="resourcePoolSystem"><p>企业服务资源池管理系统</p></div>
        </div>
        <div class="cultivation-bottom">
          <p class="cultivation-title">培育服务</p>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>企业成长培育</span>
                </div>
                <el-row>
                  <el-col v-for="item in growth" :span="12" class="growth-item">
                    <div class="growth-list" @click="fillGrowth(item,'企业成长培育')">
                      <span>{{item}}</span>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>重点项目培育</span>
                </div>
                <el-row>
                  <el-col v-for="item2 in project" :span="12" class="growth-item">
                    <div class="growth-list" @click="fillGrowth(item2,'重点项目培育')">
                      <span>{{item2}}</span>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>企业纾困帮扶</span>
                </div>
                <el-row>
                  <el-col v-for="item3 in relief" :span="12" class="growth-item">
                    <div class="growth-list" @click="fillGrowth(item3,'企业纾困帮扶')">
                      <span>{{item3}}</span>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>企业专业服务人才</span>
                </div>
                <el-row>
                  <el-col v-for="item4 in service_personnel" :span="12" class="growth-item">
                    <div class="growth-list" @click="fillGrowth(item4,'企业专业服务人才')">
                      <span>{{item4}}</span>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
export default {
  name: "index",
  components:{headerIndex,home_footer,Hang},
  data(){
    return{
      min_height: document.documentElement.clientHeight - 315,
      childNode: {},
      cid: 0,
      pName: '',
      backIndex: 0,
      growth:['融资贷款','企业信用','数字化应用','知识产权','科技能力','企业上云','企业上市','企业上规'],
      project:['高新技术企业','企业技术中心','新型研发机构','知识产权优势企业','重点软件和信息技术企业','科技型中小企业','企业研发准备金','专精特新企业'],
      relief:['人民调解','企业合规辅导','法律维权帮扶','信贷资产流转'],
      service_personnel:['服务专家','服务顾问'],
    }
  },
  methods:{
    /*企业高质量发展培育*/
    developmentCultivation(){
      this.$router.replace({
        path: '/cultivation/development_cultivation',
        query: {
          city: this.childNode.cityCode,
          cityName: this.childNode.name,
          pName:this.childNode.name+'企业数字化服务云平台',
        }
      })
    },
    /*企业服务资源池管理系统*/
    resourcePoolSystem(){
      this.$router.replace({
        path: '/cultivation/resourcePoolSystem',
        query: {
          city: this.childNode.cityCode,
          cityName: this.childNode.name,
          pName:this.childNode.name+'企业数字化服务云平台',
        }
      })
    },
    /*培育申报*/
    fillGrowth(value,type){
      this.$router.replace({
        path: '/cultivation/fillGrowth',
        query: {
          city: this.childNode.cityCode,
          cityName: this.childNode.name,
          type:value,
          systemType:type,
          pName:this.childNode.name+'企业数字化服务云平台',
        }
      })
    },
    /*需求申报*/
    declaration(){
      this.$router.replace({
        path: '/declaration/index',
        query: {
          city: this.childNode.cityCode,
          cityName: this.childNode.name,
          pName:this.childNode.name+'企业数字化服务云平台',
          backIndex:2,
        }
      })
    },
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.pName = this.$route.query.pName;
    this.backIndex = this.$route.query.backIndex;
    if (sessionStorage.getItem('childNode')) {
      this.childNode = JSON.parse(sessionStorage.getItem('childNode'));
    }
  }
}
</script>
<style scoped>
.cultivation-container >>> .cultivation-content .cultivation-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #5D5D5D;
}
.cultivation-container >>> .cultivation-content .cultivation-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.cultivation-container >>> .cultivation-content .cultivation-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.cultivation-container >>> .cultivation-content .cultivation-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.cultivation-container >>> .cultivation-content .cultivation-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #5D5D5D;
  font-family: 'SourceHanSansCN';
}
.cultivation-container >>> .cultivation-content .cultivation-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}
.cultivation-container >>> .cultivation-content .cultivation-breadcrumb .el-breadcrumb__inner a,
.cultivation-container >>> .cultivation-content .cultivation-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #333333;
}
.cultivation-container >>> .cultivation-content .cultivation-info .box-card .el-card__body, .el-main {
  padding: 0px;
}
.cultivation-container >>> .cultivation-content .cultivation-info .box-card .el-card__header {
  padding: 15px 20px;
  border-bottom: 1px solid #EBEEF5;
  box-sizing: border-box;
  background: #F2F3FB;
  font-size: 18px;
  font-family: 'SourceHanSansCN';
  color: #333333;
}
.el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
  box-shadow: 0 0px 0px 0 rgb(0 0 0 / 10%);
}
.cultivation-container >>> .cultivation-content .cultivation-info .cultivation-bottom .box-card .growth-item :nth-child(2n-1){
  border-left: 2px solid #F2F3FB;
}
</style>
<style scoped lang="scss">
.cultivation-container{
  background: #F2F3FB;
  .cultivation-content{
    .cultivation-breadcrumb {
      display: flex;
      justify-content: left;
      font-size: 14px;
      font-weight: 100;
      color: #333333;
      font-family: "SourceHanSansCN";
      padding: 10px 18%;
      min-width: 76rem;
      background: #F2F3FB;
    }
    .cultivation-info{
      .cultivation-top{
        background: url("~@/assets/img/cloud/background-cultivation.png") no-repeat;
        display: flex;
        justify-content: center;
        min-width: 76rem;
        background-size: 100% 100%;
        padding: 0px 18%;
        height: 175px;
        align-items: center;
        .cultivation-title{
          font-size: 48px;
          color: #ffffff;
          font-family: "SourceHanSansCN";
          font-weight: 500;
          letter-spacing: 4px;
          margin-block-end: 0px;
          margin-block-start: 0px;
          cursor: pointer;
          text-shadow: 0px 3px 7px rgb(42 88 104 / 35%);
        }
      }
      .cultivation-center{
        background: #F2F3FB;
        display: flex;
        justify-content: space-between;
        padding: 20px 18%;
        font-size: 18px;
        color: #ffffff;
        font-family: "SourceHanSansCN";
        min-width: 76rem;
        .cultivation-btn1{
          background: url("~@/assets/img/cloud/cultivation-btn1.png") no-repeat;
          width: 100%;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          p{
            padding-left: 30px;
          }
        }
        .cultivation-btn2{
          background: url("~@/assets/img/cloud/cultivation-btn2.png") no-repeat;
          width: 100%;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          p{
            padding-left: 90px;
          }
        }
        .cultivation-btn3{
          background: url("~@/assets/img/cloud/cultivation-btn3.png") no-repeat;
          width: 100%;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          p{
            padding-left: 90px;
          }
        }
      }
      .cultivation-bottom{
        background: #ffffff;
        padding: 40px 18%;
        min-width: 76rem;
        .cultivation-title{
          font-size: 24px;
          font-family: 'SourceHanSansCN';
          color: #333333;
          margin-block-end: 20px;
          margin-block-start: 0px;
        }
        .box-card{
          margin-bottom: 20px;
          .clearfix{
            background: #F2F3FB;
            cursor: pointer;
          }
          .growth-item{
            border-bottom: 2px solid #F2F3FB;
            cursor: pointer;
            .growth-list{
              display: flex;
              justify-content: space-between;
              padding: 15px 20px 15px 20px;
              span{
                font-size: 16px;
                color: #333333;
                font-family: 'SourceHanSansCN';
              }
              .el-icon-arrow-right{
                color: #666666;

              }
            }
          }
        }
      }
    }
  }
}
</style>